export default __webpack_public_path__ + "static/media/enlyte-logo.8332adfa.png";